module.exports = __webpack_public_path__ + "static/img/hero5.085617c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero5.png
// module id = ZRjx
// module chunks = 1